import { graphql } from 'gatsby';
import React from 'react';
import { useMicrosite } from '../../../contexts/franchise/microsite-context';
import IconButtonsSlider from '../slider/icon-buttons-slider';

const ServicesSlider: React.FC<Queries.ServicesSliderDataFragment> = (data) => {
    const {
        isMicrosite,
        permalink: micrositePermalink,
        filteredServices,
    } = useMicrosite();

    const { services } = data;

    const formattedServiceTypes: {
        label: string,
        link: ContentStackLink,
        icon: Partial<ContentStackImage>,
        sort: number
    }[] = [];

    if (filteredServices && filteredServices.length > 0) {
        filteredServices.forEach((filteredService) => {
            if (!filteredService) return;
            const { serviceType } = filteredService;
            if (!serviceType) return;
            const { link, franchiseLink, title, icon, sort } = serviceType;
            if (isMicrosite && franchiseLink && title && icon) {
                const { title: linkTitle, href: linkHref } = franchiseLink;
                formattedServiceTypes.push(
                    {
                        label: title,
                        link: { href: `${micrositePermalink}${linkHref}`, title: linkTitle },
                        icon,
                        sort: sort || 0,
                    },
                );
            } else if (!isMicrosite && link && title && icon) {
                const { title: linkTitle, href: linkHref } = link;
                formattedServiceTypes.push(
                    {
                        label: title,
                        link: { href: linkHref, title: linkTitle },
                        icon,
                        sort: sort || 0,
                    },
                );
            }
        });
    } else if (services) {
        services.forEach((service) => {
            if (!service) return;
            const { title, link, icon, sort } = service;
            if (link && title && icon) {
                const { title: linkTitle, href: linkHref } = link;
                formattedServiceTypes.push(
                    {
                        label: title,
                        link: { href: isMicrosite ? `${micrositePermalink}${linkHref}` : linkHref, title: linkTitle },
                        icon,
                        sort: sort || 0,
                    },
                );
            }
        });
    }

    if (formattedServiceTypes.length === 0) return null;

    return (
        <IconButtonsSlider slides={formattedServiceTypes as Queries.IconButtonsSliderDataFragment['slides']} />
    );
};

export const query = graphql`
    fragment ServicesSliderData on CsServicesSlider {
        ... on CsServicesSlider {
            services {
                title
                link {
                    title
                    href
                }
                franchiseServiceMapping
                icon {
                    filename
                    title
                    url
                    contentStackAsset
                }
                sort
            }
        }
    }
`;

export default ServicesSlider;
